import { createSelector } from 'reselect'

const getCommunicationSummary = (state: any) => state.audienceSummary

/** A Redux selector to retrieve Pre-registrations count
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating total pre-registrations.
 */

export const selectAudienceSummaryIsLoading = createSelector(
  getCommunicationSummary,
  (data) => data && data.status ? data.status.inProgress : false
)

/** A Redux selector to retrieve Pre-registrations count
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating total pre-registrations.
 */

export const selectPreRegistrationsCount = createSelector(
  getCommunicationSummary,
  (data) => data && data.preregistrations ? data.preregistrations : 0
)

/** A Redux selector to retrieve Viewers count
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating total viewers.
 */

export const selectViewersCount = createSelector(
  getCommunicationSummary,
  (data) => data && data.viewers ? data.viewers : 0
)

/** A Redux selector to retrieve Attendance
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating attendance.
 */

export const selectAttendance = createSelector(
  getCommunicationSummary,
  (data) => data && data.attendance ? data.attendance : 0
)

/** A Redux selector to retrieve Average minutes viewed
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating Average minutes viewed
 */

export const selectAverageMinutesViewed = createSelector(
  getCommunicationSummary,
  (data) => data && data.averageMinutesViewed ? data.averageMinutesViewed : 0
)

/** A Redux selector to retrieve Event duration
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating event duration.
 */

export const selectEventDuration = createSelector(
  getCommunicationSummary,
  (data) => data && data.eventDuration ? data.eventDuration : 0
)

/** A Redux selector to retrieve Viewers interaction
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating viewers interaction.
 */

export const selectViewerInteraction = createSelector(
  getCommunicationSummary,
  (data) => data && data.viewerInteraction ? data.viewerInteraction : 0
)

/** A Redux selector to retrieve Duration Viewed
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating duration viewed.
 */

export const selectDurationView = createSelector(
  getCommunicationSummary,
  (data) => data && data.durationView ? data.durationView : 0
)

/** A Redux selector to retrieve Duration Viewed
 * @param state - The Redux state
 * @param {Array} - Array values indicating sources.
 */

export const selectSources = createSelector(
  getCommunicationSummary,
  (data) => data && data.sources ? data.sources : null
)
